/**
 * Utilitários para formatação de dados
 */
// Formatar CNPJ para exibição
export const formatarCNPJ = cnpj => {
  if (!cnpj) return '';
  const numbers = cnpj.replace(/\D/g, '');

  if (numbers.length === 14) {
    return numbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  }

  return cnpj;
}; // Formatar CNPJ durante digitação

export const formatarCNPJInput = value => {
  const numbers = value.replace(/\D/g, '');

  if (numbers.length <= 14) {
    return numbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  }

  return value;
}; // Formatar telefone

export const formatarTelefone = value => {
  const numbers = value.replace(/\D/g, '');

  if (numbers.length <= 11) {
    return numbers.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
  }

  return value;
}; // Formatar data

// Formatar data apenas (sem hora)
export const formatarData = data => {
  if (!data) return '';
  return new Date(data).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Formatar data apenas (sem hora)
export const formatarDataSimples = data => {
  if (!data) return '';
  return new Date(data).toLocaleDateString('pt-BR');
};

// Validar CNPJ
export const validarCNPJ = cnpj => {
  cnpj = cnpj.replace(/[^\d]/g, '');

  if (cnpj.length !== 14) {
    return false;
  }

  if (/^(\d)\1+$/.test(cnpj)) {
    return false;
  }

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

  if (resultado !== parseInt(digitos.charAt(0))) {
    return false;
  }

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

  if (resultado !== parseInt(digitos.charAt(1))) {
    return false;
  }

  return true;
};

// Formatar valor monetário em BRL
export const formatarValorBRL = valor => {
  if (valor === null || valor === undefined || valor === '') {
    return 'R$ 0,00';
  }

  const numero = parseFloat(valor);

  if (isNaN(numero)) {
    return 'R$ 0,00';
  }

  return `R$ ${numero.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

// Converte Date/string para formato de API (YYYY-MM-DD quando for Date)
export const toApiDate = v => {
  if (!v) return undefined;
  if (v instanceof Date) {
    const y = v.getFullYear();
    const m = String(v.getMonth() + 1).padStart(2, '0');
    const d = String(v.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  return v; // já é string (ex.: '2025-10-08')
};

// Converte boolean/strings para 'true' | 'false'
export const toBoolString = val => {
  if (val === undefined || val === null) return undefined;
  if (val === true || val === 'true' || val === 1 || val === '1') return 'true';
  if (val === false || val === 'false' || val === 0 || val === '0') return 'false';
  return undefined;
};